import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useAuth } from "./auth";
import { Agreement } from "@busy-human/contract-module";
import { query, where } from "firebase/firestore";
import { DataInstance } from "@busy-human/gearbox";
import { getAgreements } from "@/util/functions";

export const useAgreements = defineStore('agreements', () => {
    const requests = ref(new Map<string, DataInstance<Agreement.Model<any, any>>>());
    const loading = ref(false);

    const isAgreementsReady = ref(false);
    const waitingPromises = ref<(() => void)[]>([]);

    async function reloadRequests() {
        const auth = useAuth();
        requests.value.clear();
        loading.value = true;
        if(auth.currentUid){
            try{
                const agreements = await getAgreements({agreementName: 'Canine Revolution Contract'});
                agreements.data.agreements.forEach((agreement) => {
                    requests.value.set(agreement.$id, agreement);
                });
            }catch(e){
                console.error("An error occured while trying to get pending agreements", e);
            }

            waitingPromises.value.map(res => res());
            waitingPromises.value = [];
            isAgreementsReady.value = true;
        }

        loading.value = false;
    }

    reloadRequests();

    function waitForReady() {
        if(!isAgreementsReady.value) {
            return new Promise<void>(res => {waitingPromises.value.push(res);});
        } else {return Promise.resolve();}
    }

    const asArray = computed(() => {
        const arr: DataInstance<Agreement.Model<any, any>>[] = [];
        for(const [uid, req] of requests.value) {
            arr.push(req);
        }
        return arr;
    });

    const getAgreementFromRequestId = (id: string) => asArray.value.find((r) => r.specifiers?.requestId === id);

    return { requests, loading, reloadRequests, asArray, getAgreementFromRequestId, isAgreementsReady, waitForReady};
});